import { cx } from 'class-variance-authority';
import { useReducedMotion } from 'framer-motion';
import { useEffect, useState } from 'react';

import ArtDirectionImage, {
  type ArtDirectionImageProps,
} from '../Image/ArtDirectionImage';
import type { VideoProps } from '../Video/types/VideoProps';
import Video from '../Video/Video';

export interface MotionSafeVideoProps {
  readonly image: ArtDirectionImageProps;
  readonly video: VideoProps;
}

const MotionSafeVideo = ({ image, video }: MotionSafeVideoProps) => {
  const shouldReduceMotion = useReducedMotion();
  const [hasMounted, setHasMounted] = useState<boolean>(false);
  const shouldShowVideo = Boolean(hasMounted && !shouldReduceMotion);
  const shouldShowImage = Boolean(hasMounted && shouldReduceMotion);

  useEffect(() => {
    if (!hasMounted) setHasMounted(true);
  }, [hasMounted]);

  return (
    <>
      <ArtDirectionImage
        {...image}
        className={cx('motion-safe:hidden', image.className)}
        localizedSrcSet={
          shouldShowImage && image.localizedSrcSet
            ? image.localizedSrcSet
            : undefined
        }
        srcSet={shouldShowImage && image.srcSet ? image.srcSet : undefined}
      />
      <Video
        {...video}
        className={cx('motion-reduce:hidden', video.className)}
        src={shouldShowVideo && video.src ? video.src : undefined}
        srcSet={shouldShowVideo && video.srcSet ? video.srcSet : undefined}
      />
    </>
  );
};

export default MotionSafeVideo;
